/*
 =====================
 CART
 =====================
 */
$('body').on('click', '.to-cart', function (e) {
    e.preventDefault();

    if ($(this).hasClass('loading') || $(this).hasClass('disabled')) {
        return;
    }
  
  var val = $(this).data('value');

  if (val && val !== '') {
    addItem(val, $(this));
  }
});

$('body').on('click', '.launchtip_add_to_cart', function (e) {
    e.preventDefault();

    if ($(this).hasClass('loading') || $(this).hasClass('disabled')) {
        return;
    }

    var val = $(this).siblings('[name="id"]').val();

    if (val && val !== '') {
        addItem(val, $(this));
    }
});
  

$(document).ready(function() { 
    
    // Check for upsell add to cart clicked
    $(document).on('click', '.bold-product__actions .add-to-cart', function(){
//        console.log("upsell add to cart clicked");
//        window.location.reload();
    });
  
  function checkOptions() {
  	var checkedOptions = [];
    $('.ufe-checkbox input').each(function() {
      if ($(this).is(':checked')) {
      	checkedOptions.push($(this)); 
      }
    });
    
    if (checkedOptions.length == 0) {
      $('.addtocart').show();
    } else {
      $('.addtocart').hide();
    }  
  }
  
  $('body').on('click', '.ufe-checkbox', function() {
    checkOptions();
  });
  
  
  
});

function textToNum($elem) {
    return parseFloat($elem.text());
}

function addItem(id, $elem) {
  
  updateCartCount(1);
  $elem.addClass('loading disabled');

  Shopify.addItem(id, 1, function (data) {
    var $existing = $('#cart-pane .p-' + id);
    var $temp = $('#cart-pane .cart-item.template').clone().removeClass('template');
    renderCartItem($temp, data);

    if ($existing.length) {
      $existing.replaceWith($temp);
    } else {
      $('#cart-pane').find('.cart-items').prepend($temp);
    }

    $elem.removeClass('loading');

    checkForItems();
    updateTotals();

    if ($('body').hasClass('pdp-page')) {
      $('.to-cart').addClass('added-to-cart').find('.label').html($('#cart-pane').data('added-label'));
    }

    openCart();


    if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
      BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
      BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
    }
  });
}

function quantityPlus($elem) {
    var $parent = $elem.closest('.pane-item');
    var $q = $parent.find('.qty input');
    var price = parseInt($parent.data('price'), 10);
    var val = parseInt($q.val(), 10);

    val += 1;
    $q.val(val);

    $parent.find('.price .value').text(money(val * price));

    updateCartCount(1);
    updateTotals();

    Shopify.changeItem($parent.data('product-id'), val, function (data) {
        //console.log(data);
    });
}

function quantityMinus($elem) {
    var $parent = $elem.closest('.pane-item');
    var $q = $parent.find('.qty input');
    var price = parseInt($parent.data('price'), 10);
    var val = parseInt($q.val(), 10);

    if (val > 1) {
        val -= 1;
        $q.val(val);
        $parent.find('.price .value').text(money(val * price));

        updateCartCount(-1);
        updateTotals();

        Shopify.changeItem($parent.data('product-id'), val, function (data) {
            //console.log(data);
        });
    }
}

function productRemove($elem) {
    var $parent = $elem.closest('.pane-item');
    var $q = $parent.find('.qty input');
    var val = parseInt($q.val(), 10);
    var id = $parent.data('product-id');

    var $item = $parent.fadeOut({
        duration: 250,
        easing: 'easeInOutQuint',
        complete: function () {
            $parent.remove();
            updateTotals();
            updateCartCount(-1 * val);

            Shopify.removeItem(id, function (data) {
                //console.log(data);
            });

            checkForItems();
        }
    });
}

function money(val) {
    val = decorateWithZeros(parseInt(val, 10) / 100, 2);
    var mon = $('#cart-pane').data('money');
    return mon.replace(/[0-9\.]+/, val);
}

function resetTotals() {
    var $totals = $('#cart-totals');

    var subtotal = 0;
    var total = 0;

    var $subtotal = $totals.find('.subtotal .value');
    if ($subtotal.length) {
        $subtotal.text(money(subtotal));
    }

    var $total = $totals.find('.total .value');
    if ($total.length) {
        $total.text(money(total));
    }
}

function updateTotals() {
    var $totals = $('#cart-totals');
    var $items = $('#cart-pane .pane-items .pane-item');

    if ($items.length) {
        var subtotal = 0;
        var total = 0;

        $items.each(function () {
            var qty = parseInt($(this).find('.qty input').val(), 10);
            var price = parseInt($(this).data('price'), 10);
            var original = parseInt($(this).data('original-price'));
            total += price * qty;
            subtotal += original * qty;
        });

        var $subtotal = $totals.find('.subtotal .value');
        if ($subtotal.length) {
            $subtotal.text(money(subtotal));
        }

        var $total = $totals.find('.total .value');
        if ($total.length) {
            $total.text(money(total));
        }
    } else {
        resetTotals();
    }
}

function updateCartCount(value) {
    var $elem = $('#cart-button .quantity');
    $elem.addClass('visible');
    var val = textToNum($elem);
    var final = val + value;

    final = final < 0 ? 0 : final;

    var $title = $('#cart-pane .cart-title');
    $title.find('.value').text(final);

    if (final === 0) {
        $elem.removeClass('visible');
    }

    if (final === 1) {
        $title.find('.label').text($title.data('singular'));
    } else {
        $title.find('.label').text($title.data('plural'));
    }

    $elem.html(final);
}

function resetCartCount() {
    var $elem = $('#cart-button .quantity');
    $elem.removeClass('visible');
    $elem.html(0);
}

function renderCartItem($target, item) {
    // console.log(item);
    $target.addClass('p-' + item.variant_id);
    $target.find('.image').css('background-image', 'url(' + item.image + ')');
    $target.data('final-line-price', item.final_line_price);
    $target.data('original-line-price', item.original_line_price);
    $target.data('price', item.final_price);
    $target.data('original-price', item.original_price);
    $target.find('.title').html(item.title);
    $target.find('.title').attr('href', item.url);
    $target.find('.sku').html(item.sku);
    $target.find('.image-wrap').attr('href', item.url);
    $target.find('.qty input').val(item.quantity);

    // Adding label to read by NVDA
    $target.find('a.image-wrap').attr("aria-label", item.title);

    if (item.variant_title) {
        var variant_handle = slug(item.variant_title);
        if (window.COLORS.hasOwnProperty(variant_handle)) {
            $target.find('.image-wrap .color').addClass('color-value-' + slug(item.variant_title));
        } else {
            $target.find('.image-wrap .color').remove();
        }
    }

    $target.data('product-id', item.variant_id);
    $target.find('.price .value').text(money(item.final_line_price));

    $target.find('.qty .minus').on('click', function (e) {
        e.preventDefault();
        quantityMinus($(this));
    });

    $target.find('.qty .plus').on('click', function (e) {
        e.preventDefault();
        quantityPlus($(this));
    });

    $target.find('.remove').on('click', function (e) {
        e.preventDefault();
        productRemove($(this));
    });
}

function checkForItems() {
    var $items = $('#cart-pane .pane-items .pane-item');

    if ($items.length) {
        $('#cart-pane').addClass('has-items');
        $('#cart-pane .cart-empty').stop(true).fadeOut({
            duration: 250,
            easing: 'easeInOutQuint',
            complete: function () {
                $('#cart-pane .cart-has-items').stop(true).fadeIn({
                    duration: 250,
                    easing: 'easeInOutQuint'
                });
            }
        });
    } else {
        $('#cart-pane').removeClass('has-items');
        $('#cart-pane .cart-has-items').stop(true).fadeOut({
            duration: 250,
            easing: 'easeInOutQuint',
            complete: function () {
                $('#cart-pane .cart-empty').stop(true).fadeIn({
                    duration: 250,
                    easing: 'easeInOutQuint',
                    complete: function () {
                        closePanes('cart');
                    }
                });
            }
        });
        resetCartCount();
    }
}

function renderCartItems(items) {
    var $template = $('#cart-pane .cart-item.template').clone().removeClass('template');

    for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var $temp = $template.clone();
        updateCartCount(item.quantity);
        renderCartItem($temp, item);
        updateTotals();

        $('#cart-pane').find('.pane-items').append($temp);
    }

    checkForItems();
}

function getCart(prerender, postrender) {
    $('#cart-pane').addClass('loading');

    Shopify.getCart(function (data) {
        if (prerender !== undefined) {
            prerender(data);
        }
        renderCartItems(data.items);

        $('#cart-pane').removeClass('loading');
        updateTotals();

        if (postrender !== undefined) {
            postrender(data);
        }
        document.dispatchEvent(new CustomEvent("cart-loaded"));
    });
}
getCart();

$('#cart-pane').find('button.continue').on('click', function () {
    closePanes('cart');
});